import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-result-type-incomplete",
  "use": "icon-result-type-incomplete-usage",
  "viewBox": "0 0 25 24",
  "content": "<symbol viewBox=\"0 0 25 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-result-type-incomplete\">\n    <path d=\"M14.9167 9.33333L9.58333 14.6667M14.9167 14.6667L9.58333 9.33333M20.25 12C20.25 16.4183 16.6683 20 12.25 20C7.83172 20 4.25 16.4183 4.25 12C4.25 7.58172 7.83172 4 12.25 4C16.6683 4 20.25 7.58172 20.25 12Z\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol